import React from 'react'
import Education from '../education'
import ListLevelHeader from '../../../components/utils/list-element-header'
import TextInput from '../../../components/text-input'
import PeriodPickerComponent from '../../../components/period-picker'
import TextEditor from '../../../components/text-editor'
import AIImproveButton from '../../../components/ai-improve-button/AIImproveButton'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash, faGripVertical } from '@fortawesome/free-solid-svg-icons'

class ProjectComponent extends Education {
  render() {
    const { dragListeners } = this.props
    return (
      <React.Fragment>
        <div className="education-container">
          <div className="education-header" onClick={this.toggleBody}>
            {dragListeners && (
              <div className="drag-handle" onClick={e => e.stopPropagation()} {...dragListeners}>
                <FontAwesomeIcon icon={faGripVertical} />
              </div>
            )}
            <ListLevelHeader
              what={this.state.model.title}
              where={this.state.model.location}
              period={this.state.model.period}
            />

            <div className="education-header-title education-header-arrow">{this.showArrow()}</div>
          </div>
          <div className={`education-body ${this.state.showBody ? 'open' : 'closed'}`}>
            <div className="section-basics-line">
              <TextInput
                field="title"
                label="Activity or project name, job title, etc."
                value={this.state.model.title}
                update={this.update}
              />

              <TextInput
                field="location"
                label="City"
                value={this.state.model.location}
                update={this.update}
              />
            </div>
            <div className="section-basics-line">
              <PeriodPickerComponent
                field="period"
                model={this.state.model.period}
                updatePeriod={this.update}
              />
            </div>
            <div>
              <TextEditor
                key={this.state.editorKey}
                field="summary"
                label="Description"
                value={this.state.model.summary}
                update={this.update}
              />
            </div>
            <div className="ai-improve-row">
              <AIImproveButton
                value={this.state.model.summary}
                section="project"
                onAccept={(improved) => this.acceptAI('summary', improved)}
              />
              <div className="button-remove-element" onClick={this.removeElement}>
                <FontAwesomeIcon icon={faTrash} />
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default ProjectComponent
